export const PATHS = {
  HOME_PAGE: "/",
  DOCS_PAGE: "/docs",
  ERRORS_PAGE: "/errors",
  FEEDBACK_PAGE: "/feedback",
};
